import axios from 'axios';
import { attachAuth } from '@/utils/authSession';

const apiAuthClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:9000/",
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
});

attachAuth(apiAuthClient, { optional: false });


export default {
  getNotifications(){
    return apiAuthClient.get(`/notifications`)
},
    postNotification(notification){
        return apiAuthClient.post(`/postNotification`, notification)
    },
    
    updateNotification(notification){
      return apiAuthClient.put(`/updateNotification`, notification)
  },

  savePreferences(preferences){
    return apiAuthClient.post(`/preferences/keywords`, preferences)

},
saveTopics(topics){
  // Payload may include framingSides: ['left'|'center'|'right'] | null
  // alongside retained biasMin/biasMax for migration compatibility.
  return apiAuthClient.post(`/preferences/topics`, topics)
},
getTopics(){
  return apiAuthClient.get(`/preferences/topics`)
},
deleteTopic(keyword){
  return apiAuthClient.delete(`/preferences/topics/${keyword}`)
},
getPreferences(){
  return apiAuthClient.get(`/preferences/keywords/byUser`)
},
deleteKeyword(keyword){
  return apiAuthClient.delete(`/preferences/keywords/${encodeURIComponent(keyword)}`)
},
getSettings(){
  return apiAuthClient.get('/api/notifications/settings')
},
updateSettings(body){
  return apiAuthClient.put('/api/notifications/settings', body)
},
updateGlobalSports(body){
  return apiAuthClient.put('/api/notifications/settings/sports/global', body)
},
updateSportsEntity(body){
  return apiAuthClient.put('/api/notifications/settings/sports/entity', body)
}
}